module.exports = __webpack_public_path__ + "img/hero-image-mobile.80c81f6d.jpg";